import React from 'react';
import {useField} from "formik";
import {ToggleSwitch} from '../Control';

// Component ----

export type ToggleFieldFieldProps = {
    name: string
    label: string
    description?: string
    inline?: boolean
    short?: boolean
    disabled?: boolean
    onChange?: (checked: boolean) => void
}

function ToggleField({name, label, description, inline, short, disabled, onChange}: ToggleFieldFieldProps) {
    const [field, , {setValue, setTouched}] = useField(name);

    const handleChange = (enabled: boolean) => {
        void setTouched(true)
        void setValue(enabled)

        if(onChange) onChange(enabled)
    }

    return (
        <ToggleSwitch
            label={label}
            description={description}
            multiline={!inline}
            checked={Boolean(field.value)}
            short={short}
            disabled={disabled}
            onChange={handleChange}
        />
    )
}

export default ToggleField;